import React, { FunctionComponent, useState } from 'react';
import './modal.scss';
import Check from '../../../assets/images/icons/check.png';
import Error from '../../../assets/images/icons/close.png';

import { TokenSelector } from '../token-selector/tokenSelector';
import { ActionButton } from '../action-button/actionButton';
import { useAppSelector } from '../../../features';
import { getModalTransactionStatus } from '../../../store/TransactionSlice';
import { ModalTransaction } from '../../../types/transactions';
import { Button } from '../button/button';

export const ModalTransfer : React.FC = () => {

    const modalStatus : ModalTransaction = useAppSelector(getModalTransactionStatus);

    const[balance, setBalance] = useState('---');
    const[amount, setAmount] = useState(0);
    const[token, setToken] = useState('');

    const handleOnChange = (e:any) => {
        getBalance(e);
    }

    const getBalance = (token:string) => {
        if(!token) setBalance("---");
        else {
            setToken(token);
            setBalance('200.000000')
        }
    }

    const handleAmountChange = (e:any) => {
        const val = e.target.value;
        setAmount(val);
    }

    if ( !window.location.href.includes('/profile') ) {
        return null;
    }

    return (
        <div className={`modal-wrapper ${modalStatus.status !== 'not-started' ? 'show' : 'hide'}`}>
            { modalStatus.status }
            <div className="modal">
                { modalStatus.status === 'completed' && <ModalTransferFinish />}
                { modalStatus.status === 'started' &&
                    <>
                        <div className="modal-header">
                            <h1>
                                Sacar/Transferir
                                <small>Aqui você saca ou transfere suas moedas para uma carteira especifica!</small>
                            </h1>
                        </div>
                        <div className="modal-body">

                            <div className="token-info">
                                <div className="token-info-selector flex">
                                    <div>
                                        <h2>Token de transferencia:</h2>
                                        <TokenSelector onChange={handleOnChange}/>
                                    </div>
                                    <div>
                                        <h2>Quantidade:</h2>
                                        <input 
                                            type="number" 
                                            onChange={handleAmountChange}
                                            disabled={!token}/>
                                    </div>
                                </div>
                                <h3>
                                    Saldo do Token: {balance}
                                    {Number(balance) < amount && (<small>
                                        sem saldo para esse transferência
                                    </small>)}
                                </h3>
                            </div>

                            <div className="wallet-info">
                                <h2>Carteira de destino:</h2>
                                <p>
                                    0xd283hd278...2347
                                </p>
                            </div>

                            <ActionButton 
                                label="Enviar" 
                                onClick={ () => console.dir('oi')} 
                                stylish={'btn-green'}
                                minimal={'minimal'}
                                disabled={Number(balance) < amount} />

                        </div>
                    </>
                }
            </div>
        </div>
    )
}

const ModalTransferFinish : FunctionComponent = () => {

    const modalStatus : ModalTransaction = useAppSelector(getModalTransactionStatus);

    return (
        <>
            {modalStatus.res === 'success' && (
                <div className="success-info">
                    
                    <img src={Check} alt="" />
                    
                    <div className="card">
                        <div className="card-header">
                            Transferencia/Saque bem sucedido!
                        </div>
                        <div className="card-body">
                            <p>
                                Valor (Token):
                                <span> 343.23</span>
                            </p>
                            <p>
                                Wallet:
                                <span> 0x32f32e...6f33</span>
                            </p>
                            <Button label="Finalizar" onClick={ () => console.dir('oi')}/>
                        </div>
                    </div>
                </div> 
            )}
            {modalStatus.res === 'error' && (
                <div className="error-info">
                    
                    <img src={Error} alt="" />

                    <p>
                        Lorem ipsum dolor sit, amet consectetur adipisicing elit. Sed quia odio alias saepe impedit numquam ut in eum maxime dignissimos! Sit ipsum id numquam quisquam omnis porro optio, mollitia dolor.
                    </p>

                    <Button label="Tentar novamente" onClick={ () => console.dir('oi')}/>
                </div>
            )}
        </>
    )
}